export enum Domain {
  de = 'de',
  at = 'at',
  pl = 'pl',
  sk = 'sk',
  cz = 'cz',
  it = 'it',
}

export const ALLOWED_DOMAINS = new Set<Domain>([Domain.de]);

export const domainEnvSettingsMapping: Partial<Record<Domain, string>> = {
  [Domain.de]: import.meta.env.VITE_USERCENTRICS_SETTINGS_ID_DE,
};

export const getCountryDomainFromHost = (): Domain | undefined => {
  const hostParts = window.location.host.split('.');
  const country = hostParts[hostParts.length - 1] as Domain;

  if (!Domain[country]) {
    return;
  }

  return country;
};

export const isCurrentDomainAllowed = () => {
  const country = getCountryDomainFromHost();

  return !!country && ALLOWED_DOMAINS.has(country);
};
